import { useState } from "react";
import { Card, Flex, RadioBar, Text } from "@jsq/ds/core";
import CommentInput from "./CommentInput";
import CommentLogTracker from "./CommentLogTracker";
import KYCTextComponent from "./KYCTextComponent";
import * as styles from "./styles_vanilla.css";
interface Props {
  caseId: number;
}
/**
 * This component represents the log section of the case details drawer.
 */
const Log = ({ caseId }: Props) => {
  const [isInternalComment, setIsInternalComment] = useState(true);
  return (
    <Card>
      <Text className={styles.logHeader}>LOG</Text>
      <Flex flexDirection={"row"} gap={20}>
        <Flex flexDirection={"column"} gap={10} flexBasis={"50%"}>
          <Flex flexDirection={"row"} gap={10}>
            <CommentInput
              caseId={caseId}
              isInternalComment={isInternalComment}
              commentTypeToggle={
                <RadioBar
                  className={styles.radioBar}
                  value={isInternalComment ? "internalComment" : "externalComment"}
                  onSelectOption={(selectedValue) =>
                    setIsInternalComment(selectedValue === "internalComment")
                  }
                  options={[
                    { label: "Internal comment", value: "internalComment" },
                    { label: "External comment", value: "externalComment" },
                  ]}
                />
              }
            />
          </Flex>
          <Flex flexDirection={"row"} gap={10}>
            <hr className={styles.divider} />
          </Flex>
          <Flex flexDirection={"row"} gap={10} flexBasis={"100%"}>
            <CommentLogTracker caseId={caseId} showInternal={isInternalComment} />
          </Flex>
        </Flex>
        <Flex flexDirection={"column"} gap={20} flexBasis={"50%"}>
          <KYCTextComponent />
        </Flex>
      </Flex>
    </Card>
  );
};

export default Log;
